import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class EncryptionService {
  private key: string;
  private iv: string;

  public constructor() {
    this.key = CryptoJS.lib.WordArray.random(128 / 8).toString();
    this.iv = CryptoJS.lib.WordArray.random(128 / 8).toString();
  }

  public encrypt(text: string): string {
    const encrypted = CryptoJS.AES.encrypt(text, this.key);// TODO había 3er parámetro {iv:this.iv}, versión anterior crypto.js?
    return encrypted.toString();
  }

  public decrypt(encrypted: string): string {
    const decrypted = CryptoJS.AES.decrypt(encrypted, this.key); // TODO había 3er parámetro {iv:this.iv}, versión anterior crypto.js?
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
